import React, { useContext, useEffect, useState } from "react";
import { Form, Input, Button, Checkbox, Select } from "antd";
import { UserContext } from "../../../context/UserContext";
import MetadataEditorModal from "../MetadataEditorModal";

const EditPlotModalContent = ({
  plotLabel,
  data,
  setOpen,
  updateCallback,
  allOrgs,
  allSites,
  allCrops,
  allVarieties,
}) => {
  const [form] = Form.useForm();
  const { userData } = useContext(UserContext);
  const [metadataObj, setMetadataObj] = useState(data?.metadata || {});
  const [showMetadataEditor, setShowMetadataEditor] = useState(false);

  useEffect(() => {
    form.setFieldsValue({
      organization: data.organization_id,
      site: data.site.id,
      crop: data.crop.id,
      variety: data.variety?.id,
      name: data.name,
      is_active: data.is_active,
      is_loose: data.is_loose,
      metadata: JSON.stringify(data.metadata, null, 2),
    });
  }, [data, form]);

  const onFinish = (values) => {
    values.metadata = metadataObj;
    updateCallback(data.id, values);
    setOpen(false);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="flex justify-center">
      <Form
        id="editPlotForm"
        className="max-w-[80%]"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <div className="flex items-center justify-between">
          {/* Site Dropdown - disabled */}
          <Form.Item
            name="site"
            label="Site"
            rules={[
              {
                required: true,
                message: "Please select a site",
              },
            ]}
          >
            <Select
              placeholder="Select Site"
              options={allSites}
              showSearch
              disabled // Disable the site Select
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>

          {/* Crop Dropdown - disabled */}
          <Form.Item
            name="crop"
            label="Crop"
            rules={[
              {
                required: true,
                message: "Please select a crop",
              },
            ]}
          >
            <Select
              placeholder="Select Crop"
              options={allCrops}
              showSearch
              disabled // Disable the crop Select
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>
        </div>
        <Form.Item name="variety" label="Variety">
          <Select
            placeholder="Select Variety"
            options={allVarieties}
            showSearch
            filterOption={(input, option) =>
              option.label?.toLowerCase()?.includes(input?.toLowerCase())
            }
          />
        </Form.Item>
        {/* Plot Name */}
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Name is required",
            },
          ]}
        >
          <Input placeholder={plotLabel + " Name"} />
        </Form.Item>
        <div className="flex items-center justify-between">
          {/* Active Checkbox */}
          <Form.Item name="is_active" valuePropName="checked" label="Active">
            <Checkbox></Checkbox>
          </Form.Item>

          {/* Is Loose Checkbox */}
          <Form.Item
            name="is_loose"
            valuePropName="checked"
            label="Loose Harvested"
            initialValue={false}
          >
            <Checkbox></Checkbox>
          </Form.Item>
        </div>
        {/* Metadata */}
        <Form.Item
          name="metadata"
          label="Metadata"
          rules={[
            {
              required: false,
              message: "Metadata is required",
            },
          ]}
        >
          {/*<Input.TextArea />*/}
          <Button color="primary" onClick={() => setShowMetadataEditor(true)}>
            Edit Metadata
          </Button>
        </Form.Item>

        {/* Submit Button */}
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
      <MetadataEditorModal
        name={plotLabel + " Metadata"}
        visible={showMetadataEditor}
        onClose={() => setShowMetadataEditor(false)}
        metadata={metadataObj}
        onUpdateMetadata={(updatedMetadata) => setMetadataObj(updatedMetadata)}
      />
    </div>
  );
};

export default EditPlotModalContent;
